function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
import utils from '../utils';
import InputSwitch from './input-switch';
import DPlayer from '../player';
var DPlayerEx = function (_DPlayer) {
    _inherits(DPlayerEx, _DPlayer);
    var _super = _createSuper(DPlayerEx);
    function DPlayerEx(options) {
        var _this;
        _classCallCheck(this, DPlayerEx);
        _this = _super.call(this, options);
        _this.container.DPlayer = _assertThisInitialized(_this);
        _this.playRemember = InputSwitch({
            title: '记忆播放',
            player: _assertThisInitialized(_this),
            'switch': utils.storage.get('dplayer-skip-remember-switch') === 'true',
            target: document.querySelector('.dplayer-setting-origin-panel'),
            callback: function callback(event, state, msg) {
                console.log(event, state, msg);
                utils.storage.set('dplayer-skip-remember-switch', state);
            }
        });
        _this.playRemember.toggleSwitch(true);
        _this.inputSwitchStart = InputSwitch({
            title: '跳过片头',
            tips: '单位/秒',
            input: {
                placeholder: '单位/秒',
                value: utils.storage.get('dplayer-skip-start')
            },
            player: _assertThisInitialized(_this),
            'switch': utils.storage.get('dplayer-skip-start-switch') === 'true',
            target: document.querySelector('.dplayer-setting-origin-panel'),
            callback: function callback(event, state, msg) {
                console.log(event, state, msg);
                if (~~msg <= 0) {
                    this.notice('无效片头时间');
                    this.toggleSwitch(false);
                    return false;
                }
                utils.storage.set('dplayer-skip-start', msg);
                utils.storage.set('dplayer-skip-start-switch', state);
            }
        });
        _this.inputSwitchEnd = InputSwitch({
            title: '跳过片尾',
            tips: '单位/秒',
            input: {
                placeholder: '单位/秒',
                value: utils.storage.get('dplayer-skip-end')
            },
            player: _assertThisInitialized(_this),
            'switch': utils.storage.get('dplayer-skip-end-switch') === 'true',
            target: document.querySelector('.dplayer-setting-origin-panel'),
            callback: function callback(event, state, msg) {
                console.log(event, state, msg);
                if (~~msg <= 0) {
                    this.notice('无效片尾时间');
                    this.toggleSwitch(false);
                    return false;
                }
                utils.storage.set('dplayer-skip-end', msg);
                utils.storage.set('dplayer-skip-end-switch', state);
            }
        });
        var playRememberData = utils.storage.get('dplayer-skip-remember-value') || '{}', playRememberData_src = _this.video.src;
        playRememberData = JSON.parse(playRememberData);
        var piantou = ~~_this.inputSwitchStart.value, pianwei = ~~_this.inputSwitchEnd.value, playRememberValue = playRememberData[playRememberData_src] || 0;
        var timeid = setTimeout(function () {
            console.log('记忆进度1', {
                playRememberValue: playRememberValue,
                piantou: piantou,
                pianwei: pianwei
            });
            if (playRememberValue > 0 && _this.playRemember['switch']) {
                if (_this.inputSwitchStart['switch']) {
                    playRememberValue > piantou ? _this.seek(playRememberValue) : _this.seek(piantou);
                } else {
                    _this.seek(playRememberValue);
                }
            } else if (_this.inputSwitchStart['switch']) {
                _this.seek(piantou);
            }
        }, 200);
        setTimeout(function () {
            clearTimeout(timeid);
            timeid = null;
        }, 1000);
        var RemeberReceiveMessage = function RemeberReceiveMessage(e) {
            var data = e.data;
            if (data.status === 401) {
                if (timeid > 0) {
                    clearTimeout(timeid);
                    timeid = null;
                }
                playRememberData_src = data.msg;
                playRememberValue = playRememberData[playRememberData_src] || 0;
                console.log('记忆进度2', {
                    playRememberValue: playRememberValue,
                    piantou: piantou,
                    pianwei: pianwei
                });
                if (playRememberValue > 0 && _this.playRemember['switch']) {
                    if (_this.inputSwitchStart['switch']) {
                        playRememberValue > piantou ? _this.seek(playRememberValue) : _this.seek(piantou);
                    } else {
                        _this.seek(playRememberValue);
                    }
                } else if (_this.inputSwitchStart['switch']) {
                    _this.seek(piantou);
                }
            }
        };
        window.addEventListener('message', RemeberReceiveMessage, false);
        window.parent.postMessage({
            status: 400,
            msg: 'get'
        }, '*');
        console.log([
            _this.options.video.url,
            _this.video.src,
            playRememberData_src
        ]);
        _this.speed(1.3);
        _this.on('timeupdate', function () {
            piantou = ~~_this.inputSwitchStart.value;
            pianwei = ~~_this.inputSwitchEnd.value;
            playRememberValue = _this.video.currentTime;
            playRememberValue = playRememberValue > 3 ? playRememberValue - 3 : playRememberValue;
            playRememberData[_this.video.src] = playRememberValue;
            playRememberData[playRememberData_src] = playRememberValue;
            utils.storage.set('dplayer-skip-remember-value', JSON.stringify(playRememberData));
            if (_this.inputSwitchEnd['switch'] && pianwei > 10) {
                if (pianwei - piantou > 5 && _this.video.currentTime > pianwei - 3 && _this.video.currentTime < pianwei - 2) {
                    _this.notice('即将跳过片尾');
                }
                if (_this.video.currentTime > pianwei) {
                    _this.video.currentTime = pianwei;
                    _this.pause();
                    _this.events.trigger('ended');
                }
            }
        });
        _this.on('ended', function () {
            utils.storage.set('dplayer-skip-remember', 0);
            window.parent.postMessage({
                status: 100,
                msg: '播放完了'
            }, '*');
        });
        _this.on('durationchange', function () {
            window.parent.postMessage({
                status: 200,
                msg: '可以播放'
            }, '*');
        });
        return _this;
    }
    return DPlayerEx;
}(DPlayer);
console.log('\n'.concat(' %c DPlayer Extend ', EXTEND_VERSION, ' %c https://github.com/miseli/cCDN '), 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
export default DPlayerEx;